module.exports = __webpack_public_path__ + "static/media/BusseltonDunsborougTimes-devicecomp-min.4124b478.png";